<mat-card>
  <app-card-header
    icono="sim_card"
    [title]="title"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  @if (form) {
    <mat-card-content class="card-content-crear">
      <form [formGroup]="form" autocomplete="off">
        @if (mostrarCampoCliente) {
          <section class="inputs-group">
            <div style="width: 100%">
              <app-cliente-selector
                formControlName="idCliente"
              ></app-cliente-selector>
            </div>
          </section>
        }

        <app-sim-config
          [formGroup]="form"
          title="Datos de la SIM"
          [verificarDuplicados]="!isEditing"
          [permitirMover]="false"
          [mostrarSelector]="false"
        ></app-sim-config>

        @if (!valido) {
          <small class="ayuda">
            {{
              mostrarCampoCliente
                ? 'Elegí el cliente y cargá al menos el ICCID o el número de teléfono.'
                : 'Cargá al menos el ICCID o el número de teléfono.'
            }}
          </small>
        }
      </form>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <app-button
        matType="mat-fab extended"
        color="neutral"
        (click)="cerrar()"
        text="Cancelar"
      ></app-button>
      <app-button
        matType="mat-fab extended"
        color="primary"
        [disabled]="!valido || guardando"
        [text]="guardando ? 'Guardando...' : 'Guardar'"
        icon="save"
        (click)="guardar()"
      ></app-button>
    </mat-card-actions>
  }
</mat-card>
